import {
	currencyFormatter,
	percentageFormatter,
	numericalComparator,
} from '../utils';

export const IDS_TO_COLUMN_MAPPING = {
	IN_STOCK_PERCENTAGE_THIS_YEAR_AVERAGE:'inStockPctTYAvg'
}

export const INVENTORY_COLUMNS = [
	{
		sortable: true,
		field: 'node.wmItemNm',
		headerName: 'Item Description',
		cellClass: ['pointer', 'left-aligned-text', 'item-underlined-purple'],
		pinned: 'left',
	},
	{
		sortable: true,
		field: 'node.wmItemNbr',
		headerName: 'Item Number',
		cellClass: ['pointer', 'left-aligned-text'],
	},
	{
		sortable: true,
		field: 'node.replInstkPercentageTY',
		filter: 'agNumberColumnFilter',
		headerName: 'Rpl. InStock %',
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		valueFormatter: percentageFormatter,
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'replInstockPercent_ih',
		},
	},
	{
		sortable: true,
		field: 'node.nilPickQty',
		filter: 'agNumberColumnFilter',
		headerName: 'NilPick Quantity',
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'nilPick_ih',
		},
	},
	{
		sortable: true,
		field: 'node.nilPikRate',
		filter: 'agNumberColumnFilter',
		headerName: 'NilPick %',
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		valueFormatter: percentageFormatter,
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'nilPickPercent_ih',
		},
	},
	{
		sortable: true,
		filter: 'agNumberColumnFilter',
		field: 'node.traitedStoresAvg',
		headerName: 'Avg. Traited Store Count',
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'traitedStores_ih',
		},
	},
	{
		sortable: true,
		field: 'node.inStockPctTYAvg',
		id:'inStockPctTYAvg',
		filter: 'agNumberColumnFilter',
		headerName: 'Stores with Rpl. InStock < 95%',
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text', 'item-underlined-purple'],
		minWidth: 300,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'storeWhereReplInstock_ih',
		},
	},
	{
		sortable: true,
		field: 'node.wos',
		filter: 'agNumberColumnFilter',
		headerName: 'Weeks of Supply',
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'weeksOfSupply_ih',
		},
	},
	{
		sortable: true,
		field: 'node.potentialSalesImpact',
		filter: 'agNumberColumnFilter',
		headerName: 'Potential Sales Impact',
		wrapHeaderText: true,
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		valueFormatter: currencyFormatter,
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'potentialSalesImpact_ih',
		},
	},
];

export const PRICING_COLUMNS = [
	{
		sortable: true,
		field: 'node.wmItemNm',
		headerName: 'Item Description',
		cellClass: ['pointer', 'left-aligned-text', 'item-underlined-purple'],
		pinned: 'left',
	},
	{
		sortable: true,
		field: 'node.wmItemNbr',
		headerName: 'Item Number',
		cellClass: ['pointer', 'left-aligned-text'],
	},
	{
		sortable: true,
		field: 'node.aurTY',
		filter: 'agNumberColumnFilter',
		headerName: 'AUR',
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		valueFormatter: currencyFormatter,
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'aur_pricing',
		},
	},
	{
		sortable: true,
		field: 'node.aurTYChngRef',
		filter: 'agNumberColumnFilter',
		headerName: 'AUR Chg',
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		valueFormatter: currencyFormatter,
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'aurChange_pricing',
		},
	},
	{
		sortable: true,
		field: 'node.aurTYChngPctRef',
		filter: 'agNumberColumnFilter',
		headerName: 'AUR % Chg',
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		valueFormatter: percentageFormatter,
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'aurPercentChange_pricing',
		},
	},
	{
		sortable: true,
		filter: 'agNumberColumnFilter',
		field: 'node.unitsTY',
		headerName: 'Units',
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'quantity_pricing',
		},
	},
	{
		sortable: true,
		field: 'node.unitsTYChngPctRef',
		filter: 'agNumberColumnFilter',
		headerName: 'Units % Chg',
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		valueFormatter: percentageFormatter,
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'quantityPercentChng_pricing',
		},
	},
	{
		sortable: true,
		field: 'node.potentialSalesImpact',
		filter: 'agNumberColumnFilter',
		headerName: 'Potential Sales Impact',
		wrapHeaderText: true,
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		valueFormatter: currencyFormatter,
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'potentialSalesImpact_pricing',
		},
	},
];

export const POD_COLUMNS = [
	{
		sortable: true,
		field: 'node.wmItemNm',
		headerName: 'Item Description',
		cellClass: ['pointer', 'left-aligned-text', 'item-underlined-purple'],
		pinned: 'left',
	},
	{
		sortable: true,
		field: 'node.wmItemNbr',
		headerName: 'Item Number',
		cellClass: ['pointer', 'left-aligned-text'],
	},
	{
		sortable: true,
		filter: 'agNumberColumnFilter',
		field: 'node.traitedStoresAvg',
		wrapHeaderText: true,
		headerName: 'Avg. Traited Store Count',
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'traitedStores_pod',
		},
	},
	{
		sortable: true,
		field: 'node.traitedStoresChngRefAvg',
		filter: 'agNumberColumnFilter',
		wrapHeaderText: true,
		headerName: 'Avg. Traited Store Count Chg',
		type: 'numericColumn',
		comparator: numericalComparator,
		cellClass: ['pointer', 'right-aligned-text'],
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'traitedStoresChange_pod',
		},
	},
	{
		sortable: true,
		filter: 'valid_storecount_chg',
		field: 'node.validStoreCntAvg',
		headerName: 'Avg. Valid Store Count',
		wrapHeaderText: true,
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'validstoreCount_pod',
		},
	},
	{
		sortable: true,
		filter: 'valid_storecount_chg',
		field: 'node.validStoreCntChngRefAvg',
		headerName: 'Avg. Valid Store Count Chg',
		wrapHeaderText: true,
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'validstoreCountChg_pod',
		},
	},
	{
		sortable: true,
		filter: 'pos_store_count',
		field: 'node.storeCntTYAvg',
		headerName: 'Avg. POS Store Count',
		wrapHeaderText: true,
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'posStoreCount_pod',
		},
	},
	{
		sortable: true,
		filter: 'pos_store_count',
		field: 'node.storeCntTYChngRef',
		headerName: 'Avg. POS Store Count Chg',
		wrapHeaderText: true,
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'posStoreCountChg_pod',
		},
	},
	{
		sortable: true,
		field: 'node.potentialSalesImpact',
		wrapHeaderText: true,
		filter: 'agNumberColumnFilter',
		headerName: 'Potential Sales Impact',
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		valueFormatter: currencyFormatter,
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'potentialSalesImpact_pod',
		},
	},
];

export const ASSORTMENT_COLOUMNS = [
	{
		sortable: true,
		field: 'node.wmItemNm',
		headerName: 'Item Description',
		cellClass: ['pointer', 'left-aligned-text', 'item-underlined-purple'],
		pinned: 'left',
	},
	{
		sortable: true,
		field: 'node.wmItemNm',
		headerName: 'Item Number',
		cellClass: ['pointer', 'left-aligned-text'],
	},

	{
		sortable: true,
		filter: 'agNumberColumnFilter',
		field: 'node.status',
		headerName: 'Added/Removed',
		cellRenderer: 'customBadgeComponent',
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'addedRemoved_assort',
			leftAlign: true,
		},
	},
	{
		sortable: true,
		field: 'node.changeDt',
		headerName: 'Date',
		cellClass: ['pointer', 'left-aligned-text'],
		cellRenderer: 'customDateComponent',
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'date_assort',
			leftAlign: true,
		},
	},
	{
		sortable: true,
		field: 'node.potentialSalesImpact',
		filter: 'agNumberColumnFilter',
		headerName: 'Potential Sales Impact',
		wrapHeaderText: true,
		type: 'numericColumn',
		cellClass: ['pointer', 'right-aligned-text'],
		valueFormatter: currencyFormatter,
		comparator: numericalComparator,
		headerComponent: 'customColumnHeader',
		headerComponentParams: {
			hasDefinition: true,
			definitionId: 'potentialSalesImpact_assort',
		},
	},
];
